module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e2185163"
    }
  }, [_c('b', [_vm._v("SPLIT PEA SOUP WITH HAM")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e2185663"
    }
  }, [_c('b', [_c('i', [_vm._v("This hearty old-fashioned favorite is a perfect pick-me-up on a cold blustery day.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2186863"
    }
  }, [_c('b', [_vm._v("Prep: 10 minutes Cook: 1 hour 15 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2187363"
    }
  }, [_vm._v("2 tablespoons vegetable oil")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2187663"
    }
  }, [_vm._v("2 white turnips (6 ounces each), peeled "), _c('br'), _vm._v(" and chopped (optional)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2188263"
    }
  }, [_vm._v("2 carrots, peeled and finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2188563"
    }
  }, [_vm._v("2 stalks celery, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2188863"
    }
  }, [_vm._v("1 medium onion, finely chopped")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2189263"
    }
  }, [_vm._v("1 package (16 ounces) dry split peas, rinsed "), _c('br'), _vm._v(" and picked through")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2189863"
    }
  }, [_vm._v("2 smoked ham hocks (1½ pounds)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2191063"
    }
  }, [_vm._v("8 cups water")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2191663"
    }
  }, [_vm._v("1 bay leaf")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2192263"
    }
  }, [_vm._v("1 teaspoon salt")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e2192563"
    }
  }, [_vm._v("¼ teaspoon ground allspice")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e2193663"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, heat oil over medium-high heat. Add turnips, if using, carrots, celery, and onion; cook, stirring frequently, until carrots are tender-crisp, about 10 minutes. Add split peas, ham hocks, water, bay leaf, salt, and allspice; heat to boiling over high heat. Reduce heat; cover and simmer 45 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e2196563"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Discard bay leaf. Transfer ham hocks to cutting board; discard skin and bones. Finely chop meat. Return meat to soup. Heat through. Makes 11 cups or 6 main-dish servings.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e2198763"
    }
  }, [_vm._v("Each serving: About 343 calories, 21g protein, 52g carbohydrate, 7g total fat (1g saturated), 3mg cholesterol, 1,174mg sodium.")]), _vm._v(" "), _c('p', {
    staticClass: "h4l",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e2201463"
    }
  }, [_c('b', [_vm._v("GERMAN LENTIL SOUP")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e2201963"
    }
  }, [_vm._v("Prepare as above, but omit turnips. Substitute "), _c('b', [_vm._v("1 pound lentils,")]), _vm._v(" rinsed and picked over, for peas, and substitute "), _c('b', [_vm._v("½ teaspoon thyme")]), _vm._v(" for allspice.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dbeccfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c64_r1.vue
// module id = 258
// module chunks = 0